
import { BasisType } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type NotAvailableState from "../notavailableState";

export const SET_BASISTYPES = "SET_BASISTYPES";
export class SetBasisTypes extends Action<typeof SET_BASISTYPES, BasisType[]> {
  readonly type = SET_BASISTYPES;
  protected state: NotAvailableState;

  constructor(state: NotAvailableState, data?: BasisType[]) {
    super(state, data);
    this.state = state;
  }

  public isDoable(): boolean {
    return true;
  }
  public isValid(): boolean {
    const {basisTypes} = this.state.bookingflowStateMachine.getData<NotAvailableState>();
    const isAnySelected = basisTypes !== undefined && basisTypes?.length > 0;
    return this.isDoable() && isAnySelected;
  }
}
